/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Trust_Billing_DescInputs */

const en_home_trust_billing_desc = /** @type {(inputs: Home_Trust_Billing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We pay providers when possible`)
};

const fr_home_trust_billing_desc = /** @type {(inputs: Home_Trust_Billing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous payons les prestataires dans la mesure du possible`)
};

/**
* | output |
* | --- |
* | "We pay providers when possible" |
*
* @param {Home_Trust_Billing_DescInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_trust_billing_desc = /** @type {((inputs?: Home_Trust_Billing_DescInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trust_Billing_DescInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_trust_billing_desc(inputs)
	return fr_home_trust_billing_desc(inputs)
});